<template>
    <div class="ssSystemCdMst">
        <div class="form1">
        <el-form :model="addForm" ref="addForm" label-width="120px"
            :inline="false" class="demo-ruleForm" size="mini">
            <el-form-item label="游戏机系统CD" prop="sssystemcd">
                <el-input v-model="addForm.sssystemcd"></el-input>
            </el-form-item>
            <el-form-item label="游戏机品牌" prop="ssbusiness">
                <el-input v-model="addForm.ssbusiness"></el-input>
            </el-form-item>
            <el-form-item label="游戏机系统名" prop="sssystemname">
                <el-input v-model="addForm.sssystemname"></el-input>
            </el-form-item>
        </el-form>
        <el-form :inline="true"> 
            <el-form-item class="as_btn">
                <el-button type="primary" @click="submitForm('addForm')" :disabled="btnFlag">保存</el-button>
                <el-button type="primary" @click="showAll()">全显示</el-button>
                <el-button type="primary" @click="show()">搜索</el-button>
                <el-button @click="resetForm()">重置</el-button>
            </el-form-item>
        </el-form>
        </div>
        <el-table :data="tableData" stripe style="width: 100%"  size="mini" border>
            <el-table-column prop="sssystemcd" label="SSSYSTEMCD" > </el-table-column>
            <el-table-column prop="ssbusiness" label="SSBUSINESS" > </el-table-column>
            <el-table-column prop="sssystemname" label="SSSYSTEMNAME"> </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%">
            <span>系统cd存在！是否更新系统cd主表？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false;btnFlag = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false;doupdate()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="⚠警告"
            :visible.sync="dialogVisible2"
            width="30%">
            <span>刪除系统cd({{ row.sssystemcd + '  -  ' + row.sssystemname }})需要提供刪除序列號！</span>
            <el-form :inline="true" label-width="120px" ref="seq"> 
                <el-form-item label="序列號" prop="seq">
                    <el-input v-model="addForm.seq"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible2 = false;">取 消</el-button>
                <el-button type="primary" @click="dialogVisible2 = false; dodelete() ">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'ssSystemCdMst',
  data(){
    return {
      addForm:{
          sssystemcd:'',//游戏机系统CD
          ssbusiness:'',//游戏机品牌
          sssystemname:'',//游戏机系统名
          seq:''
      },
      tableData: [],
      btnFlag:false,
      seq: {seq:''},
      row:{},
      dialogVisible: false,
      dialogVisible2:false,
      isall: false
    };
  },
  props: {
    msg: String
  },
  methods:{
    resetForm() {//重置表单
        for (const key in this.addForm) {
            this.addForm[key] = '';
        }
        this.addForm.sssystemcd = this.$route.query.sssystemcd;
    },
    submitForm(formName) {//提交表单
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let _this = this;
                _this.btnFlag = true;
                this.$axios.post('/ssBaseController/addSystemCd.do',{..._this.addForm,})
                .then(res => {  //res是返回结果
                    // console.log(res)
                    if(res == '系统cd已存在'){
                        _this.dialogVisible = true;
                    } else {
                        _this.tableData = res.list;
                        _this.$message({//消息提示框
                            message: '保存成功',
                            type: 'success',
                            showClose: true,//是否有关闭按钮
                            duration: 1000 //持续时间
                        });
                        _this.btnFlag = false;
                        _this.refreshfrom()
                    }
                }).catch(err => { _this.btnFlag = false ;console.error(err);})
            } else {
                console.error('error submit!!');
                return false;
            }
        });
    },
    showAll(){
        let _this = this;
        this.isall = true
        this.$axios.post('/ssBaseController/getSystemCd.do',)
        .then(res => {  //res是返回结果
            // console.log(res)
            _this.sssystemcd = res.eumSystemCd;
            _this.tableData = res.ssList;
        })
    },
    show(){
        let _this = this;
        this.isall = false
        this.$axios.post('/ssBaseController/getSystemCd.do', {..._this.addForm,})
        .then(res => {  //res是返回结果
            // console.log(res)
            if(res.ssList && res.ssList.length)
            _this.tableData = res.ssList;
            else{
                _this.tableData = []
                _this.$message({ message: '没有了', type: 'error', showClose: true, duration: 1000});
            }
            
        })
    },
    getList(param){
        // console.log(param);
        // let _this = this;
        // this.$axios.post('/ssBaseController/jumpSystemCd.do',param)
        // .then(res => {  //res是返回结果
        //     console.log(res)
        //     this.ssemuinnamecd = res.eumInNameCd;

        // })
    },
    handleEdit(index, row){
        this.addForm.sssystemcd = row.sssystemcd
        this.addForm.ssbusiness = row.ssbusiness
        this.addForm.sssystemname = row.sssystemname
        // console.log(index);
    },
    handleDelete(index, row){
        this.row = row;
        this.dialogVisible2 = true;
        // console.log(index);
    },
    dodelete(){
        let _this = this;
        this.btnFlag = true;
        this.handleEdit(-1, this.row)
        this.$axios.post('/ssBaseController/deleteSystemCd.do',{..._this.addForm,})
        .then(res => {
            _this.$message({ message: res, type: 'success', showClose: true, duration: 1000});
            _this.btnFlag = false;
            setTimeout(() => {
                _this.refreshfrom()
            }, 1000);
        })
        .catch(err => {
            console.error('服务器连接失败', err);
            _this.btnFlag = false;
        });
    },
    doupdate() {
        let _this = this;
        this.$axios.post('/ssBaseController/updateSystemCd.do',{..._this.addForm,})
        .then(res => {  //res是返回结果
            // console.log(res);
            _this.$message({//消息提示框
                            message: '更新成功', type: 'success', showClose: true, duration: 1000});
            _this.btnFlag = false;
            _this.refreshfrom()
        })
        .catch(err => { //请求失败就会捕获报错信息
            console.error('服务器连接失败', err);
            _this.btnFlag = false;
        });
    },
    refreshfrom(){
        if(this.isall) this.showAll(); else this.show()
    }
  },
  created:function () {//组件实例化之后执行，页面尚未显示
    this.getList(this.$route.query);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ssSystemCdMst{
  height:100%;
  width:1500px;
  margin: 0 auto;
  display:flex;
  justify-content: center;
  align-items: left;
  flex-direction:column;
}
.form1{
    width:360px;
    text-align: center;
}
</style>
